<template>
  <section
    :class="bem({
      codeView: !!route.query.code
    })"
  >
    <StravaPath :class="bem('strava-path')" />
    <StravaView
      :data="stravaDatoResponse.strava"
      :view="view"
    />
  </section>
  <div
    id="stravaMainScrollLatch"
    :class="bem('scroll-latch')"
  />
</template>

<script setup>
import query from '~/gql/strava.gql'

const bem = useBEM('StravaBanner')
const route = useRoute()

const { data: stravaDatoResponse } = await useDatoQuery({
  query,
  immediate: true,
})

const view = computed(() => {
  if (route.query.verificationRequired) {
      return 'verification-required'
  } else if (route.query.code) {
    return 'code'
  } else if (route.query.mode === 'verify') {
    return 'verifying'
  } else if (route.query.mode === 'confirmation') {
    return 'confirming'
  }

  return 'form'
})
</script>

<style lang="postcss" scoped>
.StravaBanner {
  margin-left: calc(0px - var(--outer-gutter));
  margin-right: calc(0px - var(--outer-gutter));

  @screen full {
    margin-left: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
    margin-right: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
  }

  background: linear-gradient(180deg, #F4F2EF 79.9%, #FFF 99.93%);
  min-height: calc(80dvh - var(--nav-height) - var(--promo-bar-height));
  transition-property: min-height;

  @apply relative px-3 pb-10 flex flex-col duration-300 ease-in-out;
}

.StravaBanner--code-view {
  @apply min-h-0;

  @screen smMax {
    @apply pb-0;
  }
}

.StravaBanner__strava-path {
  @apply absolute left-0 top-0 w-full;
}

.StravaBanner__scroll-latch {
  @apply md:block pt-8 -mt-8;
}
</style>